import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';

import { PreviewContent } from 'uikit/content';

import VideoBrowseCardMedia from './videoBrowseCardMedia';

import styles from '../styles/videosAdminListDragAndDropContentPreview.module.scss';
import getCoverArtUrl from '../helpers/getCoverArtUrl';

const VideosAdminListDragAndDropContentPreview = ({
  code = '',
  createdBy = null,
  description = '',
  item = null,
  metadata = null,
  onContentActionClick = () => {},
  picture = null,
  title = '',
  trigger = null,
  type = 'video',
}) => {
  const getFormattedDate = (dateString) => {
    const date = new Date(dateString);

    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const details = [{
    id: 1,
    label: i18n.t('published'),
    value: metadata?.published_at && getFormattedDate(metadata.published_at),
  }, {
    id: 2,
    label: i18n.t('code'),
    value: code,
  }, {
    id: 3,
    label: i18n.t('author'),
    value: createdBy?.name,
  }, {
    id: 4,
    label: i18n.t('unlocked'),
    value: metadata?.unlocked_at,
  }];

  const publishAction = {
    id: 1,
    onClick: (event) => {
      event.preventDefault();
      onContentActionClick({ action: 'publish', item });
    },
    icon: 'publishOutline',
    text: i18n.t('publish'),
  };
  const duplicateAction = {
    id: 2,
    onClick: (event) => {
      event.preventDefault();
      onContentActionClick({ action: 'duplicate', item });
    },
    icon: 'copy',
    text: i18n.t('duplicate'),
  };
  const deleteAction = {
    id: 3,
    onClick: (event) => {
      event.preventDefault();
      onContentActionClick({ action: 'delete', item });
    },
    icon: 'deleteOutline',
    text: i18n.t('delete'),
  };
  const actions = type === 'topic' ? [publishAction, deleteAction] : [publishAction, duplicateAction, deleteAction];
  const pictureUrl = getCoverArtUrl(picture);

  return (
    <PreviewContent trigger={trigger}>
      <PreviewContent.ContentContainer>
        <PreviewContent.ContentTopContainer>
          <PreviewContent.Cover>
            <div className={classnames(styles.popupImageContainer, { [styles[`default-${type}`]]: !pictureUrl })}>
              {pictureUrl && <img className={classnames(styles.popupImage, { [styles.isTopic]: type === 'topic' })} src={pictureUrl} alt="" />}
            </div>
            <VideoBrowseCardMedia
              isComplete={false}
              duration={metadata?.duration}
              type={type}
              shouldHideFolderIcon
            />
          </PreviewContent.Cover>
          {metadata?.has_unpublished_changes && (
            <PreviewContent.Status icon={<WarningAmberOutlined />} text={i18n.t('unpublished-changes')} />
          )}
        </PreviewContent.ContentTopContainer>
        <PreviewContent.Content title={title} description={description} details={details} />
      </PreviewContent.ContentContainer>
      <PreviewContent.Actions actions={actions} />
    </PreviewContent>
  );
};

VideosAdminListDragAndDropContentPreview.propTypes = {
  picture: PropTypes.shape({}),
  metadata: PropTypes.shape({}),
  item: PropTypes.shape({}),
  createdBy: PropTypes.shape({}),
  type: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  code: PropTypes.string,
  onContentActionClick: PropTypes.func,
  trigger: PropTypes.shape({}),
};

export default VideosAdminListDragAndDropContentPreview;
